<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员风采</router-link></li>
                <li><router-link to="">城市风采</router-link></li>
                <li class="currentNode">城市简介</li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>城市风采</a></li>
                    <li><router-link to="" class="active">城市简介</router-link></li>
                    <!-- <li><router-link to="/layout/city-food">驻京美食</router-link></li> -->
                    <li><router-link to="/layout/good-product-list">名特优产品</router-link></li>
                    <li><router-link to="/layout/cultural-heritage-list">非物质文化遗产</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>城市简介</h3>
                    <ul class="city-list">
                        <li class="city-item" v-for="city in cityList" :key="city.Id"  @click="goDetail(city)">
                            <img :src="city.ImageUrl"/>
                            <p>{{ city.Title }}</p>
                        </li>
                        <!-- <li class="city-item">
                            <img src="@/assets/image/index/office2.png"/>
                            <p>上海</p>
                        </li>
                        <li class="city-item">
                            <img src="@/assets/image/index/office3.png"/>
                            <p>可可</p>
                        </li>
                        <li class="city-item">
                            <img src="@/assets/image/index/office4.png"/>
                            <p>大连</p>
                        </li> -->
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getCityShowList
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            type: 1, // 城市简介1，名特优产品2，非物质文化遗产3
            cityList:[],
            total: 100,
            currentPage: 1,
            pageSize: 12,
         
        }
    },
    created() {
        this.getCityShowList();
    },
    methods: {
        getCityShowList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                type: this.type
            };
            getCityShowList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.cityList = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("城市列表请求失败");
                }
            })
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/city-detail',
                query: {
                    id: data.Id
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getCityShowList();
        }
    }
}
</script>

<style scoped>
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.city-list{
    padding-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.city-item{
    width: 216px;
    height: 120px;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    margin-right: 30px;

}
.city-list .city-item:nth-child(4n) {
    margin-right:0;
}
.city-item::before {
    content: "";
    width: 100%;
    height: 40px;
    background: linear-gradient(360deg, #000000 -5.09%, rgba(0, 0, 0, 0) 99.31%);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 5;
    transition: all .36s;
}
.city-item img {
    position: relative;
    width: 216px;
    height: 120px;
    z-index: 1;
}
.city-item p {
    font-family: 思源黑体 CN;
    font-size: 18px;
    text-align: center;
    color: #fff;
    position: absolute;
    width: 100%;
    top: 90px;
    left: 0;
    z-index: 10;
    transition: all .36s;
}
.city-item:hover::before  {
    height: 120px;
}
.city-item:hover p {
    top: 60px;
}
</style>